import { render } from "./ProjetosRda.vue?vue&type=template&id=0115e9fb&scoped=true"
import script from "./ProjetosRda.vue?vue&type=script&lang=js"
export * from "./ProjetosRda.vue?vue&type=script&lang=js"

import "./ProjetosRda.vue?vue&type=style&index=0&id=0115e9fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0115e9fb"]])

export default __exports__